import { render } from "./AppTooltip.vue?vue&type=template&id=e1e86d56&scoped=true"
import script from "./AppTooltip.vue?vue&type=script&lang=js"
export * from "./AppTooltip.vue?vue&type=script&lang=js"

import "./AppTooltip.vue?vue&type=style&index=0&id=e1e86d56&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e86d56"]])

export default __exports__